import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-tz-60';
import { serverTimeZone } from '../helpers/time-helpers.model';

@Pipe({
    name: 'serverTime'
})
export class ServerTimePipe implements PipeTransform {

    transform(value: Date, timeZone: string = serverTimeZone()): string {
        return value ? moment.tz(value, timeZone).format('L') : null;
    }
}
